import {createIcon} from '@chakra-ui/react';
import type {FC} from 'react';

// import LogoSVG from './Logo.svg';

type Props = {};

const Logo: FC<Props> = (props: Props) => {
  const Icon = createIcon({displayName: `linx-logo`, viewBox: `0 0 90 64`, defaultProps: props});
  return <Icon color={`whiteAlpha.700`} fill={`white`} fontSize={40} />;
};

export default Logo;
